module.exports = __webpack_public_path__ + "static/img/qrcode_investment.fb53c44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode_investment.jpg
// module id = diOD
// module chunks = 19